export default __webpack_public_path__ + "static/media/Logo_Cerchio_1000px.cc1ef4f2.svg";